import { CALL_TO_ACTION, CLICK_THROUGH_LINK, EXISTING_POST, FB_PAGE_CHOICE } from '../../../../../fields'

import { FormatExistingPostToBEParams, FormattedExistingPost } from './types'

export const formatExistingPostToBE = ({ values, tags }: FormatExistingPostToBEParams): FormattedExistingPost => {
  return {
    url_tags: tags,
    object_story_spec: {
      object_story_id: values[EXISTING_POST],
      page_id: values[FB_PAGE_CHOICE],
      link_data: {
        link: values[CLICK_THROUGH_LINK],
        call_to_action: {
          type: values[CALL_TO_ACTION].toLowerCase(),
          value: {
            link: values[CLICK_THROUGH_LINK]
          }
        }
      }
    }
  }
}
